module.exports = __webpack_public_path__ + "img/number2.cc780bfc.png";